import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PPDAY_70: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_PPDAY_70_N,
  },
  {
    pageId: PageId.CHAT_UPSELL_PPDAY_70,
  },
  {
    pageId: PageId.UPSELL_PPDAY_70,
  },
  {
    pageId: PageId.DOWNLOAD_PPDAY_70,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
